import { TrendingDown, TrendingUp } from "lucide-react";

import { IconBadge } from "@/components/IconBadge";
import { Badge } from "@/components/ui/badge";
import {
  Card,
  CardAction,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

export function SectionCards({ cards = [] }) {
  return (
    <div className="grid grid-cols-1 gap-4 px-4 *:data-[slot=card]:bg-gradient-to-t *:data-[slot=card]:from-primary/5 *:data-[slot=card]:to-card *:data-[slot=card]:shadow-xs lg:px-6 @xl/main:grid-cols-2 @5xl/main:grid-cols-4 dark:*:data-[slot=card]:bg-card">
      {cards.map((card) => {
        const up = card.trend === "up";
        const TrendIcon = up ? TrendingUp : TrendingDown;
        return (
          <Card key={card.title} className="@container/card">
            <CardHeader>
              <CardDescription>{card.title}</CardDescription>
              <CardTitle className="text-2xl font-semibold tabular-nums @[250px]/card:text-3xl">
                {card.value}
              </CardTitle>
              {card.icon ? (
                <CardAction>
                  <IconBadge icon={card.icon} tone={card.tone || "slate"} size="sm" />
                </CardAction>
              ) : null}
            </CardHeader>
            <CardFooter className="flex-col items-start gap-1.5 text-sm">
              <div className="line-clamp-1 flex flex-wrap items-center gap-2 font-medium">
                {card.footer}
                {card.badge ? (
                  <Badge variant="outline" className="gap-1 font-normal">
                    <TrendIcon className="size-3" />
                    {card.badge}
                  </Badge>
                ) : (
                  <TrendIcon className="size-4" />
                )}
              </div>
              <div className="text-muted-foreground">{card.hint}</div>
            </CardFooter>
          </Card>
        );
      })}
    </div>
  );
}
